<div class="luminary-modal">
  <div class="luminary-modal__telecell">
    <sit-icon [icon]="Icon.luminary_sign" [sizeClass]="'icon-size-20'" alt="Telecelda"></sit-icon>
    <span>
      Telecelda asociada • {{ properties?.associatedTelecellId || '---' }}
    </span>
  </div>

  <div class="luminary-modal__grid">
    <div class="luminary-modal__card luminary-modal__card--status">
      <div class="luminary-modal__card-icon">
        <sit-icon [icon]="Icon.lamp_rays" [sizeClass]="'icon-size-40'" alt="Estado"></sit-icon>
      </div>
      <div class="luminary-modal__card-text">
        <span class="luminary-modal__card-value">
          {{ getLastInteractionTimeLabel() }}
        </span>
        <span class="luminary-modal__card-label">
          {{ getStatusLabel() }}
        </span>
      </div>
    </div>

    <div class="luminary-modal__card luminary-modal__card--dimmer">
      <div class="luminary-modal__card-icon">
        <sit-icon [icon]="Icon.sliders" [sizeClass]="'icon-size-40'" alt="Dimmer"></sit-icon>
      </div>
      <div class="luminary-modal__card-text luminary-modal__card-text--right">
        <span class="luminary-modal__card-value">
          {{ properties?.dimmingStatus === 'DIM_ENABLED' ? '80%' : '100%' }}
        </span>
        <span class="luminary-modal__card-label">Dimmer</span>
      </div>
    </div>

    <div
      class="luminary-modal__card luminary-modal__card--power"
      role="button"
      tabindex="0"
      (click)="toggleStatus()"
      (keydown.enter)="toggleStatus()"
      (keydown.space)="toggleStatus()"
    >
      <div class="luminary-modal__card-icon">
        <sit-icon
          [icon]="Icon.power_white"
          [sizeClass]="'icon-size-40'"
          [alt]="getPowerActionLabel()"
        ></sit-icon>
      </div>
      <div class="luminary-modal__card-text">
        <span class="luminary-modal__card-value">{{ getPowerActionLabel() }}</span>
      </div>
    </div>

    <div class="luminary-modal__card luminary-modal__card--hours">
      <div class="luminary-modal__card-icon">
        <sit-icon [icon]="Icon.clock_clockwise" [sizeClass]="'icon-size-40'" alt="Horas conectada"></sit-icon>
      </div>
      <div class="luminary-modal__card-text luminary-modal__card-text--right">
        <span class="luminary-modal__card-value">
          {{ mockHorasUso(properties?.associatedTelecellId) }}
        </span>
        <span class="luminary-modal__card-label">Horas conectada</span>
      </div>
    </div>
  </div>

  <button class="luminary-modal__maintenance" type="button" (click)="openMaintenanceModal()">
    <sit-icon [icon]="Icon.settings_key_white" [sizeClass]="'icon-size-20'" alt="Programar mantenimiento"></sit-icon>
    <span>Programar Mantenimiento</span>
  </button>
</div>

